// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"789023e0","455":"c2be91fa"}[chunkId] + ".chunk.js";
};